import { useFeatureFlagsContext } from 'src/providers/FeatureFlagsProvider/FeatureFlags.context';

/**
 * Gate of the low-balance (threshold) auto top-up (RET-2425).
 *
 * Same shape and same reasoning as `useWalletFlag`: the wallet reads the raw
 * flag map and derives its own answer, so nothing outside this slice
 * re-renders when the flag ships.
 *
 * Pick the key by what the caller decides:
 *
 * - `isThresholdTopUpEnabled` is the raw stored flag. On its own it can belong
 *   to the defaults or to the previous workspace for one render (see
 *   `useWalletFlag`'s docblock).
 * - `hasLoadedThresholdTopUpFlag` (= `hasLoadedFeatureFlags`) is true only once
 *   THIS workspace's flags fetch has settled, success or failure.
 * - `canOfferThresholdTopUp` is both together, and is the one a VISIBILITY or
 *   a CALL decision reads: the third kind shows, and `GET …/topup/threshold`
 *   runs, only when this is true (KTD3). A failed flags fetch leaves the
 *   defaults, where the flag is `false`, so the answer fails closed.
 */
export function useThresholdTopUpFlag() {
  const { featureFlags, hasLoadedFeatureFlags } = useFeatureFlagsContext();
  const isThresholdTopUpEnabled =
    featureFlags['billing_threshold-topup'] === true;

  return {
    isThresholdTopUpEnabled,
    hasLoadedThresholdTopUpFlag: hasLoadedFeatureFlags,
    canOfferThresholdTopUp: isThresholdTopUpEnabled && hasLoadedFeatureFlags,
  };
}
